export default {
    Administrator:1,
    Director:2,
}


// WEBPACK FOOTER //
// ./src/utils/constants/applicationrole.js